import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import DatePicker from "js/components/Shared/Form/Fields/DatePicker";
import moment from "moment";
import Hidden from "@material-ui/core/Hidden";
import "./styles.css";
import {
  TicketPromedio,
  TransaccionesGlobales,
  TransaccionesPorSucursal,
  Genero,
  RangoEtario
} from "./Reportes";
import upperCase from "lodash/upperCase";
import { numberWithCommas } from "js/utils";

class ReportesCLN extends PureComponent {
  render() {
    const {
      data: {
        genero,
        rangoEtario,
        transaccionesPorSucursal,
        ticketPromedio,
        transaccionesGlobales
      },
      loading,
      variables: { fechaDesde, fechaHasta },
      info: { comercio, objetivo, lastMonth },
      info,
      onChange,
      classes
    } = this.props;
    return (
      <Grid
        xs={12}
        container
        spacing={16}
        className={`${classes.contenedorCLN} ${classes.fondoNegro}`}
        justify={"center"}
        style={{
          maxWidth: "100%",
          borderRadius: "0px",
          paddingTop: "15px"
        }}
      >
        <Grid item container xs={10}>
          <Grid xs={12} sm={6} item style={{ margin: "auto" }}>
            <Typography
              variant="h3"
              color="grey"
              className={classes.contenedorCLN}
              classes={{ root: classes.textoTituloComercio }}
            >
              {comercio}
            </Typography>
          </Grid>
          <Grid
            xs={12}
            sm={6}
            item
            container
            spacing={24}
            className={classes.contenedorCLN}
          >
            <Grid xs={12} sm={6} item>
              <Grid xs={12} item>
                <Typography
                  variant="subtitle1"
                  color="#414141"
                  className={`${classes.contenedorCLN} ${classes.textoPeriodo}`}
                >
                  PERÍODO:
                </Typography>
              </Grid>
              <Grid xs={12} item container>
                <Grid xs={4} item>
                  <Typography
                    variant="subtitle1"
                    color="#414141"
                    // eslint-disable-next-line prettier/prettier
                    className={`${classes.contenedorCLN} ${
                      classes.textoDatePicker
                    }`}
                    classes={{ root: classes.textoDatePicker }}
                  >
                    DESDE
                  </Typography>
                </Grid>
                <Grid xs={8} item>
                  <Typography
                    variant="subtitle1"
                    className={classes.textoDinamicoFecha}
                  >
                    <DatePicker
                      key="min"
                      name="min"
                      dateFormat="MMMM YYYY"
                      maxDate={moment()}
                      views={["year", "month"]}
                      openTo="year"
                      startOfDate
                      input={{
                        onChange: onChange("fechaDesde"),
                        value: moment(fechaDesde, "YYYYMM")
                      }}
                      className={`${classes.datePicker} ${
                        classes.contenedorCLN
                      }`}
                      InputProps={{
                        className:
                          classes.input +
                          " " +
                          classes.contenedorCLN +
                          classes.textoDinamicoFecha
                      }}
                    />
                  </Typography>
                </Grid>
              </Grid>
              <Grid xs={12} item container>
                <Grid xs={4} item>
                  <Typography
                    variant="subtitle1"
                    color="#414141"
                    className={classes.contenedorCLN}
                    classes={{ root: classes.textoDatePicker }}
                  >
                    HASTA
                  </Typography>
                </Grid>
                <Grid xs={8} item>
                  <Typography
                    variant="subtitle1"
                    className={classes.textoDinamicoFecha}
                  >
                    <DatePicker
                      key="max"
                      name="max"
                      dateFormat="MMMM YYYY"
                      maxDate={moment()}
                      views={["year", "month"]}
                      openTo="year"
                      startOfDate
                      className={`${classes.datePicker} ${
                        classes.contenedorCLN
                      }`}
                      input={{
                        onChange: onChange("fechaHasta"),
                        value: moment(fechaHasta, "YYYYMM")
                      }}
                      InputProps={{
                        className: classes.input + " " + classes.contenedorCLN
                      }}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Hidden xsDown>
              <div className={classes.verticalDivider} />
            </Hidden>
            <Grid xs={12} sm={5} item>
              <Typography
                variant="subtitle1"
                color="black"
                className={classes.textoFijoObjetivo}
              >
                {lastMonth &&
                  objetivo &&
                  `OBJETIVO ${upperCase(
                    moment(lastMonth, "MM/YYYY").format("MMMM YYYY")
                  )}`}
              </Typography>
              <Typography
                variant="subtitle1"
                color="primary"
                className={classes.contenedorCLN}
                classes={{ root: classes.textoDinamicoObjetivo }}
              >
                {lastMonth &&
                  objetivo &&
                  `${numberWithCommas(objetivo) || "--"} transacciones`}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {!loading && (
          <Fragment>
            <Grid
              xs={12}
              sm={10}
              container
              item
              spacing={16}
              className={classes.contenedorCards}
            >
              <Grid item xs={12} sm={6}>
                <Card raised={true}>
                  <TransaccionesGlobales
                    data={transaccionesGlobales}
                    info={info}
                    classes={classes}
                  />
                </Card>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Card raised={true}>
                  <TicketPromedio data={ticketPromedio} classes={classes} />
                </Card>
              </Grid>
              <Grid item xs={12}>
                <TransaccionesPorSucursal
                  data={transaccionesPorSucursal}
                  classes={classes}
                />
              </Grid>
            </Grid>
            <Grid
              xs={12}
              container
              item
              spacing={16}
              className={classes.fondoBlanco}
              justify={"center"}
            >
              <Grid
                item
                xs={12}
                sm={4}
                className={classes.fondoBlanco}
                container
                justify={"center"}
              >
                <Grid item xs={12} container justify={"center"}>
                  <Typography
                    variant="h6"
                    color={"primary"}
                    className={classes.titulosInferiores}
                  >
                    Género
                  </Typography>
                </Grid>
                <Grid item xs={12} container justify={"center"}>
                  <Genero data={genero} classes={classes} />
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={8}
                className={classes.fondoBlanco}
                container
              >
                <Typography
                  variant="h6"
                  color={"primary"}
                  className={classes.titulosInferiores}
                >
                  Rango etario
                </Typography>
                <RangoEtario data={rangoEtario} classes={classes} />
              </Grid>
            </Grid>
          </Fragment>
        )}
      </Grid>
    );
  }
}

ReportesCLN.propTypes = {
  classes: PropTypes.object
};

ReportesCLN.defaultProps = {
  data: PropTypes.any
};

ReportesCLN.displayName = "ReportesCLN";

export default ReportesCLN;
